import type { ReactNode } from 'react';
import { Group, Text } from '@mantine/core';

interface CardSectionProps {
  title?: ReactNode;
  /** Npr. info ikona s tooltipom — stoji odmah iza naslova. */
  titleInfo?: ReactNode;
  headerRight?: ReactNode;
  children: ReactNode;
}

export const CardSection = ({ title, titleInfo, headerRight, children }: CardSectionProps) => (
  <div
    style={{
      borderRadius: 12,
      backgroundColor: 'var(--color-bg-surface)',
      border: '1px solid var(--color-border-default)',
      overflow: 'hidden'
    }}
  >
    {title && (
      <div
        style={{
          minHeight: 48,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: 12,
          padding: '10px 20px',
          borderBottom: '1px solid var(--color-border-soft)'
        }}
      >
        <Group gap={6} wrap="nowrap">
          <Text fz={14} fw={600} style={{ color: 'var(--color-text-primary)' }}>
            {title}
          </Text>
          {titleInfo}
        </Group>
        {headerRight}
      </div>
    )}
    {children}
  </div>
);
